export class HostAPIBase {
    constructor(platformApiMethods) {
        this.platformApiMethods = platformApiMethods;
        this.accessibility = {
            setAdvancedSettings: async (_value) => {
                // TODO;
                return;
            },
            getAdvancedSettings: async () => {
                // TODO;
                return true;
            },
        };
        this.editor = {
            openLinkPanel: (options) => {
                /**
                 * editor API does not care
                 * about appData and token seems it is historical artifact
                 */
                const appData = {};
                const token = {};
                return this.platformApiMethods.editor.openLinkPanel(appData, token, options);
            },
            openMediaPanel: (options) => {
                /**
                 * editor API does not care
                 * about appData and token seems it is historical artifact
                 */
                const appData = {};
                const token = {};
                return this.platformApiMethods.editor.openMediaPanel(appData, token, options);
            },
            openFontPicker: (options, onFontChange, onFontChangedV2) => {
                /**
                 * editor API does not care
                 * about appData and token seems it is historical artifact
                 */
                const appData = {};
                const token = {};
                return this.platformApiMethods.editor.openFontPicker(appData, token, options, onFontChange, onFontChangedV2);
            },
            openColorPicker: (options, onColorChange) => {
                /**
                 * editor API does not care
                 * about appData and token seems it is historical artifact
                 */
                const appData = {};
                const token = {};
                return this.platformApiMethods.editor.openColorPicker(appData, token, options, onColorChange);
            },
            registerToolsPanel: async (appData, toolsMenuItemConfig, toolsPanelConfig) => {
                return this.platformApiMethods.editor.registerToolsPanel(appData, toolsMenuItemConfig, toolsPanelConfig);
            },
            selection: {
                getSelectedComponents: () => {
                    return this.platformApiMethods.editor.selection.getSelectedComponents();
                },
                getSingleSelectedOrThrow: () => this.platformApiMethods.editor.selection.getSingleSelectedOrThrow(),
            },
            info: {
                getEditorSessionId: () => {
                    return this.platformApiMethods.editor.info.getEditorSessionId();
                },
            },
        };
    }
}
//# sourceMappingURL=HostAPIBase.js.map